import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useTemplate } from '../features/template/TemplateProvider';
import AxiosAPI from '../utils/AxiosAPI';
import { MainLoadingIcon } from '../utils/SVGIcon';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

function AuthProvider({ children }) {
    const [authInfo, setAuthInfo] = useState(null);
    const [rand, setRand] = useState(0);

    const { setMessage } = useTemplate();

    useEffect(() => {
        AxiosAPI()
            .setPath('/api/auth')
            .get()
            .then(({ data }) => {
                setAuthInfo(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.toString() });
            });
    }, [setMessage, rand]);

    const value = useMemo(() => {
        // const handel

        const isAuthenticated = () => {
            if (!authInfo) return null;
            return authInfo.status === 0;
        };

        const getProfile = () => authInfo?.data?.profile || {};

        const authStateUpdated = () => {
            setRand((prev) => prev + 1);
        };

        return {
            authInfo,
            permissionAll: authInfo?.data?.permissionAll || [],
            rand,
            setAuthInfo,
            isAuthenticated,
            getProfile,
            authStateUpdated
        };
    }, [authInfo, rand]);

    if (authInfo === null) {
        return (
            <div className="fixed h-28 w-28 bg-white top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="h-28 w-28 text-secondary">
                    <MainLoadingIcon />
                </div>
            </div>
        );
    }

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthProvider;
